import $http from '../../shared/http';

export const membership_requests = {
  namespaced: true,
  state: () => {
    return {
      membershipRequests: [],
    };
  },
  getters: {
    getIsMembershipMembershipRequests: (state) => state.membershipRequests,
  },
  mutations: {
    setMembershipRequests: (state, payload) => (state.membershipRequests = payload),
  },
  actions: {
    async LOAD_MEMBERSHIP_REQUESTS(ctx, { orgId, query, requestType }) {
      return $http('v2').get(`organisations/${orgId}/membership_requests/${requestType}`, {
        notifiable: true,
        params: query,
      });
    },
    async LOAD_FIRST_FIVE_MEMBERSHIP_REQUESTS(ctx, { orgId, requestType }) {
      return $http('v2').get(
        `organisations/${orgId}/membership_requests/${requestType}/first_five`,
        {
          notifiable: true,
        }
      );
    },

    async LOAD_MEMBERSHIP_REJECTION_REASONS_FOR_SELECT() {
      return $http('v2').get(`church_membership_rejection_reasons/select`, {
        notifiable: true,
      });
    },

    async ACCEPT_ALL_MEMBERSHIP_REQUESTS(ctx, { orgId, form }) {
      return $http('v2').post(`organisations/${orgId}/membership_requests/approve_all`, form);
    },
  },
};
